/*!
 * © 2024. The EGT Universe. All Rights Reserved.
 * License: Requires ACTIVE AppArtisan Subscription.
 * For mor information visit: https://egtuniverse.com/legal
 * 
 * Created for Universe App Tools.
 * 
 * Created by Justin K Kazmierczak.
 */
var _ = require("../../../uam/module.js")(module.exports, {
    namespace: "ua.element.validation.error",
    title: "UAE Error Message",
    description: "An error message from a ua control.",
    styling: {
        styles: [
            {
                selector: "#alertError",
                styles: [
                    "display: block;"
                ]
            }
        ]
    },
    fields: {
        "title": {
            title: "Title",
            type: "string",
            description: "The title of the error.",
            default: "Looks like we need your help."
        },
        "doc": {
            title: "Document",
            type: "object",
            description: "The Save() document that failed validation.",
            required: true
        }, "inner": {
            title: "Inner",
            type: "inner",
            description: "Additional content to display on top of the errors."
        }
    },
    passthrough: {
        except: ["inner", "doc", "id", "name"]
    }
});
// var namespace = module.exports.namespace;

// var f = require("../scripts/f.js");
// var uae = require("../interface/element.js");
var uai = require("../interface/interface.js");

// var define = {
//     namespace: "ua.element.validation.error",
//     title: "UAE Error Message",
//     description: "An error message from a ua element.",
//     fields: {
//         "title": {
//             type: "string",
//             description: "The title of the error.",
//             default: "Looks like we need your help."
//         },
//         "doc": {
//             type: "object",
//             description: "The Save() document that failed validation.",
//             required: true
//         }, "inner": {
//             type: "inner",
//             description: "Additional content to display on top of the errors."
//         }
//     },
//     passthrough: {
//         except: ["inner", "doc", "id", "name"]
//     }
// }; module.exports.define = define;


/**
 * Renders the error message.
 * @param {*} options The jsonObject to render.
 * @returns The final renderalbe object, dom or ua/json.
 */
exports.render = async function (options) {
    var doc = (options && options.doc && typeof options.doc === "object") ? options.doc : {};
    var title = (options && options.title) ? options.title : _.define.fields.title.default;

    var header = [{
        "n": "h1",
        "i": [
            { "n": "i", "class": "bi bi-exclamation-circle" },
            { "n": "span", "i": [" ", title] }
        ]
    }];

    if ("inner" in (options || {})) {
        header.push(options.inner);
    }

    var errorList = [];
    var alt = false;

    for (var key in doc) {
        if (key === "success" || key === "errors" || key === "selector") continue;
        if (!(doc[key]) || doc[key].success === true) continue;

        var control = document.querySelector(`uae[name="${key}"]`);
        if (!control) {
            control = document.querySelector(`[name="${key}"]`);
        }

        var goTo = false;
        if (control) {
            var id = control.id || uai.generateRandomID(24);
            control.id = id;
            goTo = {
                "n": "ua.a.incenter",
                "c": "btn btn-sm btn-outline-secondary ms-2",
                "goto": `#${id}`,
                "i": [{ "n": "i", "class": "bi bi-box-arrow-right me-1" }, "Go to field"]
            };
        }

        var labelText = key;
        if (control) {
            var label = control.querySelector("label");
            if (label && label.innerText) {
                labelText = label.innerText.trim();
            } else if (control.getAttribute("title")) {
                labelText = control.getAttribute("title");
            } else if (control.getAttribute("name")) {
                labelText = control.getAttribute("name");
            }
        }

        var controlErrors = doc[key].errors;
        if (!(controlErrors instanceof Array)) {
            controlErrors = controlErrors ? [controlErrors] : [];
        }

        var messages = [];
        for (var i = 0; i < controlErrors.length; i++) {
            var e = controlErrors[i] || {};
            var parts = [];
            if (e.title) parts.push(e.title + ":");
            if (e.description) parts.push(e.description);
            else if (e.message) parts.push(e.message);
            else parts.push("This field needs attention.");
            if (e.namespace) parts.push("(" + e.namespace + ")");
            var msg = parts.join(" ").trim();
            if (!(messages.includes(msg))) messages.push(msg);
        }

        if (messages.length === 0) {
            messages.push("This field needs attention.");
        }

        var messagesDivs = messages.map(function(message) {
            return { "n": "div", "c": "p-1", "i": message };
        });

        var errorClass = alt ? "bg-black text-white" : "bg-white text-black";
        alt = !alt;

        var titleRow = {
            "n": "div",
            "c": "d-flex align-items-center justify-content-between",
            "i": [{
                "n": "strong",
                "i": labelText
            }]
        };
        if (goTo) {
            titleRow.i.push(goTo);
        }

        errorList.push({
            "n": "li",
            "class": `p-2 rounded mb-3 tiny-outline ${errorClass}`,
            "i": [
                titleRow,
                { "n": "div", "i": messagesDivs }
            ]
        });
    }

    if (errorList.length === 0) {
        errorList.push({
            "n": "li",
            "class": "p-2 rounded tiny-outline bg-white text-black",
            "i": "We found an issue in your submission. Please review the form and try again."
        });
    }

    return {
        "n": "div",
        "id": "alertError",
        "class": "alert alert-primary tiny-outline",
        "role": "alert",
        "i": [
            header,
            {
                "n": "ul",
                "class": "list-unstyled mb-0",
                "i": errorList
            }
        ]
    };


}

/**
 * 
<div id="alertError" class="alert alert-primary tiny-outline box-shadow" style="display: block;" role="alert">
    <h1><i class="bi bi-exclamation-circle"></i> ${title}</h1>
        <ul class="list-unstyled">
           <!-- alternate between bg-info and bg-warning -->
            <li class="p-2 rounded mb-3 text-shadow tiny-outline bg-info text-white"><strong class="text-capitalize">${This would be the element's label.}</strong>: {$validation message or messages} <a href="${this needs to either be a lookup on the name or a button that scrolls to the objects center}" class="text-reset">(<i class="bi bi-box-arrow-right"></i> go to) </a></li>
            <li class="p-2 rounded mb-3 text-shadow tiny-outline bg-warning text-white"><strong class="text-capitalize">${This would be the element's label.}</strong>: {$validation message or messages} <a href="${this needs to either be a lookup on the name or a button that scrolls to the objects center}" class="text-reset">(<i class="bi bi-box-arrow-right"></i> go to) </a></li>
        </ul>
</div>

                        {
    "success": false,
    "year": {
        "success": true,
        "data": "2022",
        "errors": [],
        "namespace": "ua.select.dropdown"
    },
    "make": {
        "success": true,
        "data": "Chevrolet",
        "errors": [],
        "namespace": "ua.select.dropdown"
    },
    "model": {
        "success": true,
        "data": "BoltEV",
        "errors": [],
        "namespace": "ua.select.dropdown"
    },
    "color": {
        "success": false,
        "data": "",
        "errors": [
            {
                "input": {
                    "id": "dubUF0ddWZM9j4",
                    "name": ""
                },
                "message": "Please fill out this field.",
                "type": "validation"
            },
            {
                "type": "validation",
                "message": "Please fill out this field."
            }
        ],
        "namespace": "ua.select.dropdown"
    },
    "type": {
        "success": true,
        "data": "Sedan",
        "errors": [],
        "namespace": "ua.select.group"
    },
    "lastDetail": {
        "success": true,
        "data": "",
        "errors": [],
        "namespace": "ua.input"
    }
}
 */
